<template>
  <v-dialog v-model="show" max-width="45.75rem" persistent>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-text-container">
          <h1 v-if="!form.id" class="modal-text-title">{{ adminText('organizationAll.create_a_new_ticket_category_f5e04711', 'Create a new Ticket Category') }}</h1>
          <h1 v-else class="modal-text-title">{{ adminText('organizationAll.edit_ticket_category_77b4a28a', 'Edit Ticket Category') }}</h1>
        </div>
        <v-icon color="#979797" class="close-icon" @click="handleButtonClick('close')">
          close
        </v-icon>
      </div>
      <div class="main-container">
        <text-field
          id="name"
          v-model.trim="form.name"
          :label="adminText('organizationAll.category_name_e8830701', 'Category name*')"
          type="text"
          :validator="$v.form.name"
        />
        <div class="select-row-container">
          <v-select
            v-model="form.color"
            box
            :validator="$v.form.color"
            :label="adminText('organizationAll.select_category_color_24cfc528', 'Select category color*')"
            :items="colors"
            style="flex: 3"
            :error-messages="organizationMessages(getErrors($v.form.color))"
            @input="$v.form.color && $v.form.color.$touch()"
            @blur="$v.form.color && $v.form.color.$touch()"
          >
            <template v-slot:selection="{ item }">
              <div class="color" :style="{ background: item.hexadecimal }" />
              {{ organizationText(item.name) }}
            </template>
            <template v-slot:item="{ item }">
              <div class="color" :style="{ background: item.hexadecimal }" />
              {{ organizationText(item.name) }}
            </template>
          </v-select>
          <select-field
            v-model="form.priority"
            :validator="$v.form.priority"
            :label="adminText('organizationAll.category_priority_0c0e0447', 'Category Priority*')"
            :items="priorities"
            item-render="title"
            item-select="id"
            style="flex: 1"
          />
        </div>
        <textarea-field
          id="description"
          v-model.trim="form.description"
          :label="adminText('organizationAll.description_55f8ebc8', 'Description')"
          type="text"
        />
        <v-checkbox
          v-model="form.displayIfSoldOut"
          hide-details
          :label="adminText('organizationAll.display_the_category_and_all_its_tickets_on_c_6fc59106', 'Display the category and all its tickets on core-event.co ticket webshop if all tickets in the category are sold out')"
        />

        <!-- <pre>{{ $v }}</pre> -->
      </div>
      <div v-if="!form.id" class="buttons-container" style="justify-content: flex-end">
        <main-button @click="handleButtonClick('create-category')"> {{ adminText('organizationAll.create_category_61495a81', 'Create category') }}</main-button>
      </div>
      <div v-else class="buttons-container" style="justify-content: space-between">
        <!-- TODO: add disabling if at least one ticket in this category exists -->
        <main-button color="error" flat @click="handleButtonClick('delete')"> {{ adminText('organizationAll.delete_f6fdbe48', 'Delete') }} </main-button>
        <main-button @click="handleButtonClick('update')"> {{ adminText('organizationAll.update_fb91e24f', 'Update') }} </main-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { defaultMessages, getValidationErrors } from '@/utils'
import { cloneDeep } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { uniqueTicketCategoryPriority } from './../../../validators'

export default {
  mixins: [OrganizationLocalization],
  name: 'manage-ticket-categories-modal',
  components: {},
  props: {
    show: Boolean,
    initialValues: Object,
    colors: Array,
    priorities: Array,
    categories: Array,
  },
  data() {
    return { form: cloneDeep(this.initialValues) }
  },
  validations() {
    return {
      form: {
        name: { required },
        color: { required },
        priority: {
          required,
          uniqueTicketCategoryPriority: uniqueTicketCategoryPriority(this.categories, this.form.id),
        },
      },
    }
  },
  methods: {
    handleButtonClick(action) {
      if (['close', 'delete'].includes(action)) {
        this.$emit(action, this.form)
        this.$v.$reset()

        return
      }

      if (this.$v.form.$invalid) {
        this.$emit('warning-message', 'Fill in the required information.')

        return
      }

      this.$emit(action, this.form)
    },
    getErrors: function (field) {
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style scoped>
.modal-container {
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(51, 51, 51, 0.2);
  border-radius: 0.75rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.modal-header {
  display: flex;
  align-items: baseline;
}
.modal-text-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.modal-text-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.close-icon {
  cursor: pointer;
  user-select: none;
}
.select-row-container {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
}
.buttons-container {
  display: flex;
  flex-direction: row;
}
.color {
  width: 12px;
  height: 12px;
  border-radius: 10000px;
  margin-right: 0.5rem;
}
</style>
